module.exports = __webpack_public_path__ + "static/media/loader.f289087a.png";